import { render, staticRenderFns } from "./LowBalanceNotice.vue?vue&type=template&id=e70a5054&scoped=true&"
import script from "./LowBalanceNotice.vue?vue&type=script&lang=js&"
export * from "./LowBalanceNotice.vue?vue&type=script&lang=js&"
import style0 from "./LowBalanceNotice.vue?vue&type=style&index=0&id=e70a5054&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70a5054",
  null
  
)

export default component.exports